import { createFileRoute } from '@tanstack/react-router'

import { AccessDeniedPage } from '@/features/leave/pages/AccessDeniedPage'

export const Route = createFileRoute('/_authenticated/access-denied')({
  component: AccessDeniedPage,
})
